import React from "react";
import { MessageCircle, Phone } from "lucide-react";

export default function StudentDetailContactActions({ viewingStudent, theme }) {
  return (
    <div className="grid grid-cols-2 gap-3 w-full mb-10">
      <a
        href={`tel:${viewingStudent.phone}`}
        className={`py-4 rounded-3xl ${
          theme?.bg || "bg-[#354F38]"
        } text-white font-bold text-lg flex items-center justify-center gap-2 shadow-lg ${
          theme?.shadow || "shadow-[#354F38]/20"
        } hover:opacity-90 hover:scale-[0.98] active:scale-[0.95] transition-all duration-200`}
      >
        <Phone size={20} fill="currentColor" /> 전화
      </a>
      <a
        href={`sms:${viewingStudent.phone}`}
        className="py-4 rounded-3xl bg-[#FFECA1] text-[#4A3B10] font-bold text-lg flex items-center justify-center gap-2 shadow-lg shadow-yellow-400/20 hover:bg-[#FFD54F] hover:scale-[0.98] active:scale-[0.95] transition-all duration-200"
      >
        <MessageCircle size={20} /> 문자
      </a>
    </div>
  );
}
